<template>
  <div id="historique">
    <b-container class="bv-example-row">
      <div style="padding-top: 2%">
        <div class="container-title-page">
          <div class="box-text-content-title">
            <h2>MON HISTORIQUE DE VOYAGES</h2>
            <p>
              <strong
                >Il faut bien revenir, si on veut repartir! Vous trouverez
                toutes les informations relatives à vos voyages passés afin d’en
                garder un souvenir intarissable.</strong
              >
            </p>
          </div>
        </div>
        <!-- <div class="circles_page">
          <img class="little_circle" src="../assets/little_circle.svg" />
          <img class="big_circle" src="../assets/big_circle.svg" />
        </div> -->
        <div>
          <div
            class="historique"
            v-for="(trip, index) in triplist.inactive"
            :key="'inactive-' + index"
          >
            <TripCard :trip="trip" :isActive="0" />
            <br />
          </div>
        </div>
        <div>
          <div class="historique" v-if="triplist.inactive && triplist.inactive.length === 0">
            <p class="empty">Vous n'avez pas de voyage passé.</p>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import TripCard from "@/components/TripCard";

import { mapState, mapActions } from "vuex";
export default {
  name: "Historique",
  components: {
    TripCard,
  },
  props: {
    trip: Object,
    isActive: Number,
  },
  computed: {
    ...mapState({
      triplist: (state) => state.triplist.list,
    }),
  },
  methods: {
    ...mapActions(["getTripList"]),
  },
  mounted() {
    this.getTripList(0);
  },
  data: () => ({
    jourAvantDepart: 0,
    moisAvantDepart: 0,
  }),
};
</script>
<style lang="css" scoped>
.title {
  font-size: 20px;
  font-weight: bold;
}
.historique {
  background: white;
  padding-top: 30px;
  border-radius: 20px;
}
.carte {
  cursor: pointer;
}
.carte:hover .imageCarte {
  -webkit-transform: scale(0.8);
  transform: scale(1.1);
}
.carte:hover {
  -webkit-transform: scale(0.8);
  transform: scale(1.05);
}
.redtext {
  color: red;
}
.imageCarte {
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  min-height: 250px;
  position: relative;
  cursor: pointer;
}
</style>
